import { map, mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { webLogsService } from "../../../common/services";
import * as actionTypes from "./actionTypes";
import * as weblogsActions from "./actions";

export function savePageVisitLogs(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_PAGE_VISIT_LOGS),
    mergeMap(({ payload }) => {
      return webLogsService.savePageVisitLogs(payload).pipe(
        map((res) =>
          weblogsActions.savePageVisitLogsSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

export function getPageVisitLogs(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_PAGE_VISIT_LOGS),
    mergeMap(({ payload }) => {
      return webLogsService.getPageVisitLogs(payload).pipe(
        map((res) =>
          weblogsActions.getPageVisitLogsSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
